module.exports = __webpack_public_path__ + "img/life-red.da59b1c3.svg";